import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoRelatorioService } from '../../../services/projeto-relatorio.service';
import { map } from 'jquery';

@Component({
  selector: 'app-projeto-relatorio-3',
  templateUrl: './projeto-relatorio-3.component.html',
  styleUrls: ['./projeto-relatorio-3.component.scss']
})
export class ProjetoRelatorio3Component extends BaseListComponent<any> implements OnInit {
  @Input() report_1_param_1: number = 0;
  @Input() report_3_param_1: number = 0
  @Input() filter_question: number = 0;
  @Input() report_type: number = 1;
  @Input() filter_agency: number[] = [];

  listData:any;
  listData2:any = [
    {
      process_name: 'Programa de Infraestrutura',
      question_name: 'Categoria de Investimento',
      process_presentation: 'Este programa visa atender as demandas de infraestrutura em todo o estado, priorizando obras de saneamento e transporte.',
      
      PpPreProject: [
        {
          name: 'Projeto Água e Saneamento',
          items: [
            { title: 'Ampliação da rede de água em Porto Alegre' },
            { title: 'Melhoria do sistema de esgoto em Caxias do Sul' },
          ]
        },
        {
          name: 'Projeto Transporte Urbano',
          items: [
            { title: 'Reforma de terminais rodoviários' },
            { title: 'Implantação de faixas exclusivas para ônibus' },
          ]
        }
      ],

      PpPreProject2: [
        { ds_value: 'Saneamento', tot_pleitos: 5, tot_cost_without_loan: 1200000.50, tot_cost_loan: 800000 },
        { ds_value: 'Transporte', tot_pleitos: 3, tot_cost_without_loan: 950000, tot_cost_loan: 500000 },
        { ds_value: '', tot_pleitos: 2, tot_cost_without_loan: 300000, tot_cost_loan: 150000 }
      ],
      PpPreProject3: null
    },
    {
      process_name: 'Programa de Educação',
      question_name: 'Tipo de Projeto',
      process_presentation: 'Este programa foca em melhorias nas escolas e capacitação de professores em todo o estado.',

      PpPreProject: [
        {
          name: 'Projeto Escolas',
          items: [
            { title: 'Reforma de escolas estaduais' },
            { title: 'Ampliação de bibliotecas escolares' }
          ]
        },
        {
          name: 'Projeto Capacitação',
          items: [
            { title: 'Treinamento de professores em novas metodologias' },
            { title: 'Cursos de atualização pedagógica' }
          ]
        }
      ],

      PpPreProject2: [
        { ds_value: 'Infraestrutura Escolar', tot_pleitos: 4, tot_cost_without_loan: 800000, tot_cost_loan: 400000 },
        { ds_value: 'Capacitação', tot_pleitos: 6, tot_cost_without_loan: 500000, tot_cost_loan: 250000 }
      ]
    }
  ];
  listLocalExecType:any;
  listLocalBenType:any;
  jsonArray: any[];

  constructor(
    private projetoRelatorioService: ProjetoRelatorioService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.get();
  }

  sumTotals(items:any):any {
    let result = {};
    result['tot_pleitos'] = items?.reduce((sum, item) => sum + item.tot_pleitos, 0) ?? 0;
    result['tot_cost_without_loan'] = items?.reduce((sum, item) => sum + Number(item.tot_cost_without_loan), 0) ?? 0;
    result['tot_cost_loan'] = items?.reduce((sum, item) => sum + Number(item.tot_cost_loan), 0) ?? 0;
    return result;
  }

  getListType(list: any, item: number,def: string): string {
    if(list[item]) {
      return list[item].label;
    }

    return def;
  }

  isJsonArray(value: any): boolean {
    this.jsonArray = [];
    
    try {
      if(Array.isArray(JSON.parse(value))) {
        this.jsonArray = JSON.parse(value);
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  onPrint(): void {
    window.print();
  }
  
  get() {
    this.loading();
    let filter ={
      report_type: this.report_type,
      report_1_param_1: this.report_1_param_1,
      report_3_param_1: this.report_3_param_1,
      filter_agency: this.filter_agency,
      filter_question: this.filter_question
    };
    this.addSub(
      this.projetoRelatorioService.getData(this.report_type, filter).subscribe({
        next: (res) => {
          this.listData = res.data;
          this.listLocalExecType = res.listLocalExecType;
          this.listLocalBenType = res.listLocalBenType;

          this.loaded();
          
          this.cdr.detectChanges();
          setTimeout(() => {
            this.onPrint();
          }, 100);
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

}
